// redux-persist writes to IndexedDB asynchronously. A full page reload right after a
// state change (e.g. login) can cut that write off on slower phones, so the app comes
// back logged out. Flush first, then reload.
let boundPersistor = null;

export const bindPersistor = (persistor) => {
	boundPersistor = persistor;
};

export const flushPersistedState = () => {
	if (!boundPersistor) return Promise.resolve();
	const flush = Promise.resolve(boundPersistor.flush()).catch(() => {});
	// Never block navigation forever if IndexedDB hangs.
	const timeout = new Promise((resolve) => setTimeout(resolve, 1500));
	return Promise.race([flush, timeout]);
};

export const flushThenNavigate = (path) =>
	flushPersistedState().then(() => {
		window.location.href = path;
	});
